<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">

          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="keyword"
          />

          <label class="search-label" >状态</label>
          <Select v-model="status" class="search-input" clearable> 
            <Option
              v-for="item in statusIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >工作类型</label>
          <Select v-model="work_type_id" class="search-input" clearable> 
            <Option
              v-for="item in workTypeIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >平台</label>
          <Select v-model="live_id" class="search-input" @on-change="liveChange" clearable> 
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >视频分类</label>
          <Select v-model="video_classify_id" class="search-input" @on-change="videoClassifyChange" clearable> 
            <Option
              v-for="item in videoClassifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >执行账号</label>
          <Select v-model="user_id" class="search-input" clearable filterable> 
            <Option
              v-for="item in userIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button @click="handleButtonSearch" class="search-btn"type="primary"
            >搜索</Button>
        </Col>
      </Row>

      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="编辑字幕提取任务"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
        ref="editCheckSrtTask"  
       @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Forms from "./edit_check_srt_form.vue";
import Tables from "_c/tables/table-only.vue";
import saveAs from '@/api/FileSaver';

import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

import { getCheckSrtTaskList, editCheckSrtTask, finishCheckSrtTask, getCheckSrtDetail, deleteCheckSrt, resetCheck, getStrategyUser, getShortVideoWorkTypeList, getShortVideoClassify, getLiveType, endCheckSrt} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addWxChat:false,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      editMaxCount: false,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      wxContacts:[],
      statusIds:[{id: -1, name: "全部"}, {id: 0, name: "排队中"}, {id: 1, name: "提取中"},{id: 2, name: "提取完成"},{id: 3, name: "提取失败"},{id: 4, name: "已完成"},{id: 5, name: "任务终止"}],
      live:"",
      userIds:[],
      user_id:'',
      keyword:'',
      userIds:[],
      liveIds:[],
      workTypeIds:[],
      videoClassifyIds:[],
      live_id:'',
      work_type_id:'',
      video_classify_id:'',
      status:-1,
      columns: [
      {title: 'id',width: 100, align: "center", key: "id",
        render: (h, params) => {
            let texts = params.row.shortVideoTask.id;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
        }},
        { title: "id", width: 100, key: "id", editable: true, align: "center" },
        {
          title: "自动化",
          key: "status",
          width: 100, align: "center",
          render: (h, params) => {
            var texts = "手动"
            if (params.row.shortVideoTask.auto) {
              texts = "自动"
            }
            return h(
              "div",
              {
                props: {},
                style: {
                  color: params.row.shortVideoTask.auto ? "#ff0000" : "#515a6e"
                }
              },
              texts
            );
          },
        },
        { title: "执行人" , key: "nickname", editable: true, align: "center",
        render: (h, params) => {
          var texts = ""
          var list = params.row.shortVideoTask.list
          if (list.length != 0){
            for(var i = 0; i < list.length; i ++){
              texts += list[i].username + "\n"
            }
          }
          return h(
              "pre",
              texts
            );
          }},
        { title: "类型" , key: "work_type_name", editable: true, align: "center",
        render: (h, params) => {
            let texts = params.row.shortVideoTask.work_type_name;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
        }},
        { title: "分类" , key: "video_classify", editable: true, align: "center",
        render: (h, params) => {
            let texts = params.row.shortVideoTask.video_classify;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
        }},
        { title: "标题" , key: "", editable: true, align: "center",
        render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '70px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.shortVideoTask.video_title),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.shortVideoTask.video_title)
                ])
              ])
            }},
        { title: "视频地址" , key: "url", editable: true, align: "center",render: (h, params) => {
            return params.row.shortVideoTask.url != '' ?h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl =='https://in.sinano-ai.com/api'? params.row.shortVideoTask.id_url: params.row.shortVideoTask.url);
                    },
                  },
                },
                "下载"
              )
            ]): h('span', '');
          }},        
        { title: "字幕地址" , key: "srt_path", editable: true, align: "center", render: (h, params) => {
            return params.row.shortVideoTask.short_video_work_type_id == 1 && params.row.status >= 2 ?h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.downloadSrt(params);
                    },
                  },
                },
                "下载"
              )
            ]): h('span', '');
          }},
          {
          title: "状态",
          key: "status",
          width: 100, align: "center",
            render: (h, params) => {
              var texts = "已完成"
            if (params.row.status == 0){
              texts = "排队中"
            }else if (params.row.status == 1){
              texts = "提取字幕中"
            }else if (params.row.status == 2){
              texts = "提取成功"
            }else if (params.row.status == 3){
              texts = "提取失败"
            }else if (params.row.status == 5){
              texts = "任务终止"
            }

            var color = '#03A9F4'
            if (params.row.status == 3){
              color = "#ff0000"
            }else if (params.row.status == 4){
              color = "#515a6e"
            }

            return h(
              "div",
              {
                props: {},
                style:{
                  color:color
                }
              },
              texts
            );
          },
        },
        { title: "创建时间" , key: "create_time", editable: true, align: "center" },
        { title: "完成时间" , key: "finish_time", editable: true, align: "center"},
        {
          title: "Handle",
          key: "handle", align: "center",
          render: (h, params) => {
            return h("div", [
            params.row.status != 5 && params.row.status != 4 ?h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handResetCheck(params);
                    },
                  },
                },
                "重新提取"
              ):h('span', ''),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ), params.row.status != 4 && params.row.status != 5?h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleFinish(params);
                    },
                  },
                },
                "完成"
              ):h('span', ''), 
              params.row.status !=5 ?h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleEnd(params);
                    },
                  },
                },
                "终止"
              ):h('span', ''),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "error",
              //       size: "small",
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.handleDelete(params);
              //       },
              //     },
              //   },
              //   "删除"
              // )
            ]);
          },
        }
      ],
      tableData: [],
    };
  }, watch: {
    '$route': function (to, from) {
      // 路由发生变化时，重新获取数据
      this.handleSearch();
    }
  },
  methods: {
    handleButtonSearch(){
      this.page = 1
      this.handleSearch()
    },
    handleEnd(params){
      this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认终止任务？</p>',
            onOk: () => {
              endCheckSrt(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    handResetCheck(params){

      this.$Modal.confirm({
            title: '提示',
            content: '<p>是否重新提取？</p>',
            onOk: () => {
              let data = new FormData();
              data.set("id", params.row.id);
              resetCheck(data).then((res) => {
                if (res.data.code == 200) {
                  this.handleSearch()
                  this.$Message.success("成功");
                }
              });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });


    },
    downloadSrt(params){
      var params = {
        id:params.row.id
      }
      getCheckSrtDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          var srt_array =  JSON.parse(detailData.srt_json)
          var srtContent = this.generateSRT(srt_array)

          const blob = new Blob([srtContent], { type: 'text/plain' });
          // 保存文件
          saveAs(blob, detailData.id + '.srt');
        }
      });

    }, generateSRT(subtitles) {
      let srtContent = '';
      subtitles.forEach((subtitle, index) => {
        const sequenceNumber = index + 1;
        const startTime = subtitle.startTime
        const endTime = subtitle.endTime
        srtContent += `${sequenceNumber}\n${startTime} --> ${endTime}\n${subtitle.text}\n\n`;
      });
      return srtContent;
    },
    download(url){
      window.open(url, '_blank');
    },
    showEditModal(params) {
      this.$router.push({ name: "check_srt_form", query: {id:params.row.id}});
      // this.addModal = true;
      // this.$refs.editCheckSrtTask.setEditData(params.row)
    },
    addSumit(formValidate) {
      var blackItems = formValidate.blackItems
      var goodItems = formValidate.goodItems

      const data = {
        black_comment: JSON.stringify(blackItems),
        good_comment: JSON.stringify(goodItems),
        video_desc: formValidate.video_desc,
        video_title: formValidate.video_title,
        srt_path: formValidate.srt_path,
        text: formValidate.text,
      };

      editCheckSrtTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status:this.status,
        live_id:this.live_id,
        keyword:this.keyword,
        user_id:this.user_id,
        work_type:this.work_type_id,
        video_classify:this.video_classify_id
      };
      getCheckSrtTaskList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteCheckSrt(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },videoClassifyChange(value){
      this.getStrategyUser()

    },liveChange(value){
      this.getStrategyUser()

    },getStrategyUser(){
      var params = {
        short_video_classify: this.video_classify_id,
        live_id: this.live_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({id: user.id.toString(), name: user.username})
        }
        this.userIds = data
      });

    },
    handleFinish(params){

      if (params.row.status == 4){
        this.$Message.error('任务已完成');
        return
      }

      this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认提交任务？</p>',
            onOk: () => {
              finishCheckSrtTask(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch();
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.getStrategyUser()
    this.handleSearch();
    getLiveType({}).then((res) => {
        if (res.data.code == 200) {
          var lives = res.data.data;
          var data = new Array()
          for (var i = 0; i < lives.length; i++) {
            data[i] = { id: lives[i].id.toString(), name: lives[i].name }
          }
          this.liveIds = data
        }
      }); 

      getShortVideoWorkTypeList().then((res) => {
        var workType = res.data.data.records;
        var data = new Array()
          for (var i = 0; i < workType.length; i++) {
            data[i] = { id: workType[i].id.toString(), name: workType[i].name }
          }
          this.workTypeIds = data
      });

      getShortVideoClassify({}).then((res) => {
        var workType = res.data.data.records;
        var data = new Array()
          for (var i = 0; i < workType.length; i++) {
            data[i] = { id: workType[i].id.toString(), name: workType[i].name }
          }
          this.videoClassifyIds = data
      });
  },
};
</script>
